/// <reference path="../../../setup/_references.ts" />
module onvio.clientDashboard.IdentityComponent {
    'use strict';

    export class IdentityController {
        public contact: cs.IContactWithExpansionV6Dto;
        public substring: string;

        private getPhoto(): string {
            if (this.contact && this.contact.contactImageExpanded && this.contact.contactImageExpanded.imageData) {
                return 'data:image/png;base64,' + this.contact.contactImageExpanded.imageData;
            }

            return null;
        }

        private getInitials(): string {
            if (!this.contact) {
                return '';
            }

            var initials = [];

            if (this.contact.givenName &&  this.contact.givenName !== '') {
                initials.push(this.contact.givenName.charAt(0));
            }

            if (this.contact.familyName &&  this.contact.familyName !== '') {
                initials.push(this.contact.familyName.charAt(0));
            }

            if (initials.length === 0) {
                initials.push(this.contact.fullName.charAt(0));
            }

            return initials.join('').toUpperCase();
        }
    }

    export class IdentityComponent implements ng.IComponentOptions {
        bindings: any = {
            contact: '<',
            substring: '@'
        };
        controller = IdentityController;
        templateUrl = 'client-dashboard/components/client-dashboard-components/identity-component.html';
    }

    angular.module('onvio.clientDashboard.IdentityComponent', [])
            .component('contactIdentity', new IdentityComponent());
}
